import { LitElement, html } from 'lit';
import { property, customElement, state } from 'lit/decorators.js';

import '@awesome.me/webawesome/dist/components/card/card.js';
import '@awesome.me/webawesome/dist/components/button/button.js';
import '@awesome.me/webawesome/dist/components/icon/icon.js';

// You can also import styles from another file
// if you prefer to keep your CSS seperate from your component
import { homeStyles } from './app-home.styles';
import './../hero/hero.component.js';
import './../mission/mission.component.js';
import './../transparency/transparency.component.js';
import './../iar/iar.component.js';
import './../market/market.component.js';
import './../paymentpopup/paymentpopup.component.js';
import './../orderpopup/orderpopup.component.js';
import './../footer/footer.component.js';
import { styles as sharedStyles } from './../../../shared.styles';
import { OrderApi } from '../../../infrastructure/orders/order-api';

type PaymentTab = 'register' | 'buy' | 'donate';

interface MarketActionEventDetail {
  actionType: 'waze' | PaymentTab | 'custom';
}

@customElement('app-home')
export class AppHome extends LitElement {
  // For more information on using properties and state in lit
  // check out this link https://lit.dev/docs/components/properties/
  @property() message = 'Welcome!';
  @state() counter = 0;
  @state() private paymentPopupOpen = false;
  @state() private paymentTab: PaymentTab = 'register';
  private readonly orderCreator = new OrderApi({
    baseUrl: import.meta.env.VITE_API_URL ?? '',
    paymentUrls: {
      register:
        'https://checkout.baccredomatic.com/Mzc0OTgxLjkzNmQ1YTliODZiYTI5NjQxNzg3MTc3Njg1',
      jersey:
        'https://checkout.baccredomatic.com/ODZmOTY3MzA2MTZiOTIzNjJhLjI3YzExNzg3MTc3Nzc4',
      tshirt:
        'https://checkout.baccredomatic.com/NmNhMzY3NWI5MC5jMjQ3MDc0NTY4NjkxNzg3MTc3NzM1',
      donation: {
        10: 'https://checkout.baccredomatic.com/NDI3N2E4NjY4LjA4NjRhMGU2MjczOGYxNzg3MTc3NjE1',
        25: 'https://checkout.baccredomatic.com/NDBhMzYxMGU2MDVlMDc2MDYyNS5hNzgxNzg3MTc3NTQx',
        50: 'https://checkout.baccredomatic.com/MjE2NDUwMjUyMjQ4Mi5hYTg4NjA2MjgxNzg3MTc3NDg4',
        100: 'https://checkout.baccredomatic.com/LmIzODQ2YTk3NjRhMmMyMTM2OTg4OGQxNzg3MTc3Mzk2',
      },
    },
  });

  static styles = [sharedStyles, homeStyles];

  share() {
    navigator.share({
      title: 'PWABuilder pwa-starter',
      text: 'Check out the PWABuilder pwa-starter!',
      url: 'https://github.com/pwa-builder/pwa-starter',
    });
  }

  render() {
    return html`
      <rftw-hero @register-click=${this._handleRegisterClick}></rftw-hero>
      <rftw-mission id="mission"></rftw-mission>
      <rftw-transparency
        @donate=${this._handleDonateClick}
      ></rftw-transparency>
      <rftw-iar id="iar-nosara"></rftw-iar>
      <rftw-market
        id="participar"
        @market-action=${this._handleMarketAction}
      ></rftw-market>
      <rftw-footer></rftw-footer>
      <rftw-payment-popup
        .open=${this.paymentPopupOpen}
        .activeTab=${this.paymentTab}
        .orderCreator=${this.orderCreator}
        .orderPaymentConfirmer=${this.orderCreator}
        @payment-popup-close=${this._closePaymentPopup}
      ></rftw-payment-popup>
      <rftw-order-popup
        .open=${this.orderPopupOpen}
        .orderReader=${this.orderCreator}
        .orderPaymentConfirmer=${this.orderCreator}
        @order-popup-close=${this._closeOrderPopup}
      ></rftw-order-popup>
    `;
  }

  updated(): void {
    const sectionId = window.location.hash.slice(1);
    if (sectionId) {
      this.scrollToSection(sectionId, 'auto');
    }
  }

  scrollToSection(
    sectionId: string,
    behavior: ScrollBehavior = 'smooth'
  ): void {
    const section = this.renderRoot.querySelector<HTMLElement>(
      `#${CSS.escape(sectionId)}`
    );
    section?.scrollIntoView({ behavior, block: 'start' });
  }

  increment() {
    this.counter++;
  }

  private _handleMarketAction = (
    event: CustomEvent<MarketActionEventDetail>
  ) => {
    const { actionType } = event.detail;
    if (
      actionType === 'register' ||
      actionType === 'buy' ||
      actionType === 'donate'
    ) {
      this.paymentTab = actionType;
      this.paymentPopupOpen = true;
    }
  };

  private _handleDonateClick = () => {
    this.paymentTab = 'donate';
    this.paymentPopupOpen = true;
  };

  private _handleRegisterClick = () => {
    this.scrollToSection('participar');
  };

  private _closePaymentPopup = () => {
    this.paymentPopupOpen = false;
  };

  @state() private orderPopupOpen = false;

  openOrderPopup() {
    this.orderPopupOpen = true;
  }

  private _closeOrderPopup = () => {
    this.orderPopupOpen = false;
  };
}

